module.exports = __webpack_public_path__ + "static/media/RA32S.86f3102c.gif";